import {Grid, GridProps} from "@mantine/core";
import {useMemo} from "react";
import {dvirsSelector, PersonEntity, useGetLatestPersonDVIRsQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {DVIRDataTable} from "../../data-table/DVIRDataTable/DVIRDataTable";
import {useApp} from "../../../providers/RegionProvider/RegionProvider";

export type PersonDVIRViewProps = Omit<GridProps, 'children'> & {
  person: PersonEntity
}

export const PersonDVIRView = (props: PersonDVIRViewProps) => {
  const {
    person,
    ...rest
  } = props

  const {regionId} = useApp()

  const selectDVIRs = useMemo(() => {
    return dvirsSelector();
  }, []);

  const arg = useMemo(() => {
    if (regionId) {
      return {
        regionId: regionId,
        personId: person.id,
      }
    } else {
      return skipToken
    }
  }, [regionId, person.id])

  const {dvirs, isLoading, isFetching} = useGetLatestPersonDVIRsQuery(arg, {
    selectFromResult: (result) => ({
      dvirs: selectDVIRs(result),
      isLoading: result.isLoading,
      isFetching: result.isFetching,
    })
  });

  return (
    <Grid {...rest}>
      <Grid.Col span={12}>
        <DVIRDataTable
          withBorder
          records={dvirs}
          recordsPerPageOptions={[10, 25, 50, 75, 100]}
          fetching={isLoading || isFetching}
        />
      </Grid.Col>
    </Grid>
  )
}
